import { useEffect, useState } from "react";
import { Tooltip } from "antd";
import { _fetchVehicleLogos, getVehicleLogoUrl } from "../../helpers";

// Same brand-logo CDN cache WorkflowCard.js's VehicleBox uses on the sales
// pipeline board — reused here so the gallery header shows the same logos
// instead of introducing a second lookup. Falls back to the brand name as
// text (still tooltipped) when the CDN has no logo for it.
export function VehicleLogoBadge({ brandName, height = 14, textColor = "white", hideFallback = false, onAvailabilityChange }) {
  const [logo, setLogo] = useState(() => ({ brandName, url: getVehicleLogoUrl(brandName) }));
  const logoUrl = logo.brandName === brandName ? logo.url : getVehicleLogoUrl(brandName);

  useEffect(() => {
    let active = true;
    const cached = getVehicleLogoUrl(brandName);
    setLogo({ brandName, url: cached });
    if (!cached && brandName) _fetchVehicleLogos().then(() => { if (active) setLogo({ brandName, url: getVehicleLogoUrl(brandName) }); }).catch(() => {});
    return () => { active = false; };
  }, [brandName]);
  useEffect(() => { onAvailabilityChange?.(Boolean(logoUrl)); }, [logoUrl, onAvailabilityChange]);

  if (!brandName || (!logoUrl && hideFallback)) return null;

  return (
    <Tooltip title={brandName}>
      {logoUrl ? (
        <img src={logoUrl} alt={brandName} onError={() => setLogo({ brandName, url: null })} style={{ height, width: height * 1.5, objectFit: "contain", flexShrink: 0 }} />
      ) : (
        <span style={{ fontSize: 10, fontWeight: 700, color: textColor, flexShrink: 0 }}>{brandName}</span>
      )}
    </Tooltip>
  );
}
